export const testimonialsData = {
  badge: "TESTIMONIALS",
  headline: "Hear from Our Satisfied Clients",
  description:
    "Here is what some of our clients have to say about their experience of working with us.",
  ctaButton: {
    text: "Get Started",
    link: "#contact",
  },
  testimonials: [
    {
      rating: 5,
      text: "Starting out, we had the followers but not the bookings. Within two months of implementing their marketing strategy, our consultation room was fully booked three weeks in advance. They truly understand the 'quiet luxury' branding our patients expect.",
      name: "James Olding",
      position: "Aura Skin Institute",
      avatar: "/assets/images/testimonials/avatar1.png",
    },
    {
      rating: 5,
      text: "To be honest, I was skeptical because I’ve been burned by agencies before. But the difference here was that they actually understood my schedule. They set up a system that handles the constant 'is this available?' messages while I’m actually with patients. I can finally focus on the clinical side knowing the calendar is filling up in the background. It’s been a massive relief.",
      name: "Sophie Shotter",
      position: "Velvet Veil Aesthetics",
      avatar: "/assets/images/testimonials/avatar2.png",
    },
    {
      rating: 5,
      text: "We wasted so much time with general agencies who just didn’t ‘get’ our world. These guys actually speak the language. It’s a breath of fresh air to work with people who know the industry — our injectable bookings have literally doubled since we switched.",
      name: "Julian De Silva",
      position: "Lumière Aesthetic",
      avatar: "/assets/images/testimonials/avatar3.png",
    },
  ],
};
